import { Button } from 'react-bootstrap';
import styles from './ResumeButton.module.scss';
import libraryStyles from '../../SCSS/LibraryCard.module.scss';
import { showRightArrowWhiteIcon } from '../../core/core';

const ResumeButton = ({ percentComplete, ...otherProps }) => (
  <div className={styles.resumeButton}>
    <Button {...otherProps}>Resume&nbsp;{showRightArrowWhiteIcon()}</Button>
    <div className={`${libraryStyles.LibraryCard} ${libraryStyles.unitPercentComplete}`}>
      {percentComplete}%&nbsp;Complete
    </div>
  </div>
);

export default ResumeButton;
